import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@mui/material';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [lang, setLang] = useState('es');

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      setVisible(true);
    }
    const navLang = navigator.language || navigator.userLanguage;
    if (navLang.startsWith('en')) setLang('en');
  }, []);

  const t = {
    es: {
      bannerText: 'Usamos cookies propias y de terceros para mejorar tu experiencia. Puedes aceptar todas o configurar tus preferencias.',
      acceptAll: 'Aceptar todas',
      configure: 'Configurar',
      modalTitle: 'Configuración de cookies',
      modalDesc:
        'Selecciona qué tipos de cookies quieres permitir. Las cookies técnicas son necesarias para el funcionamiento del sitio y no se pueden desactivar.',
      technical: 'Cookies técnicas (obligatorias)',
      analytics: 'Cookies analíticas (medición y estadísticas)',
      marketing: 'Cookies de marketing (publicidad personalizada)',
      cancel: 'Cancelar',
      save: 'Guardar configuración',
    },
    en: {
      bannerText: 'We use our own and third-party cookies to improve your experience. You can accept all or configure your preferences.',
      acceptAll: 'Accept all',
      configure: 'Configure',
      modalTitle: 'Cookie Settings',
      modalDesc:
        'Select which types of cookies you want to allow. Technical cookies are required for the site to function and cannot be disabled.',
      technical: 'Technical cookies (required)',
      analytics: 'Analytics cookies (measurement and statistics)',
      marketing: 'Marketing cookies (personalized ads)',
      cancel: 'Cancel',
      save: 'Save settings',
    },
  }[lang];

  const handleAcceptAll = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    localStorage.setItem('analyticsCookies', 'true');
    localStorage.setItem('marketingCookies', 'true');
    setVisible(false);
  };

  const handleSaveConfig = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    localStorage.setItem('analyticsCookies', analytics.toString());
    localStorage.setItem('marketingCookies', marketing.toString());
    setShowModal(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      {/* Banner inferior */}
      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: 10, sm: 0 },
          left: { xs: 12, sm: 0 },
          right: { xs: 12, sm: 'auto' },
          width: { xs: 'calc(100% - 24px)', sm: '100%' },
          bgcolor: 'rgba(255,255,255,0.96)',
          boxShadow: 4,
          zIndex: 1300,
          p: { xs: 1.25, sm: 2 },
          borderRadius: { xs: 3, sm: 0 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
        role="dialog"
        aria-live="polite"
        aria-label="Aviso de cookies"
      >
        <Typography variant="body2" sx={{ mb: 1, maxWidth: 700, fontSize: { xs: '0.72rem', sm: '0.875rem' }, lineHeight: { xs: 1.35, sm: 1.5 } }}>
          {t.bannerText}
        </Typography>
        <Box sx={{ display: 'flex', gap: { xs: 1, sm: 2 }, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Button variant="contained" color="primary" size="small" onClick={handleAcceptAll} sx={{ fontWeight: 800, px: { xs: 1.75, sm: 2 } }}>
            {t.acceptAll}
          </Button>
          <Button variant="outlined" color="primary" size="small" onClick={() => setShowModal(true)} sx={{ fontWeight: 800, px: { xs: 1.75, sm: 2 } }}>
            {t.configure}
          </Button>
        </Box>
      </Box>

      {/* Modal de configuración */}
      <Dialog open={showModal} onClose={() => setShowModal(false)}>
        <DialogTitle>{t.modalTitle}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>{t.modalDesc}</Typography>
          <FormGroup>
            <FormControlLabel control={<Checkbox checked disabled />} label={t.technical} />
            <FormControlLabel
              control={<Checkbox checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />}
              label={t.analytics}
            />
            <FormControlLabel
              control={<Checkbox checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />}
              label={t.marketing}
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowModal(false)}>{t.cancel}</Button>
          <Button onClick={handleSaveConfig} variant="contained" color="primary">
            {t.save}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CookieBanner;


